/** What the meeting page already knows about the row, without a second fetch. */
export interface IMeetingJargonGate {
  /** The meeting row has loaded. A missing row must not fetch suggestions. */
  meetingLoaded: boolean
  /** Lite meetings hide Jargon (ADR 0045). */
  isLite: boolean
}

/**
 * Jargon suggestions are for a loaded, finished Full meeting. The suggestions
 * route itself only requires workspace membership. Live meetings have none yet,
 * and Lite hides the feature.
 */
export function shouldLoadMeetingJargon(hasCompany: boolean, isLive: boolean, gate: IMeetingJargonGate): boolean {
  return hasCompany && gate.meetingLoaded && !isLive && !gate.isLite
}
